export class Admin {
    public role: string;
    public name: string;
    public email: string;
}


// WEBPACK FOOTER //
// ./src/common/modules/admin/models/Admin.ts